import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  cashier: null,
  showNewCashierModal: false,
  showCashierInfosModal: false,
  cashierPaymentMethods: [],
};

const cashierSlice = createSlice({
  name: "cashiers",
  initialState,
  reducers: {
    setCashier: (state, action) => {
      state.cashier = action.payload;
    },
    setShowNewCashierModal: (state, action) => {
      console.log("setShowNewCashierModal", action.payload);
      state.showNewCashierModal = action.payload;
    },
    setShowCashierInfosModal: (state, action) => {
      state.showCashierInfosModal = action.payload;
    },
    setCashierPaymentMethods: (state, action) => {
      state.cashierPaymentMethods = action.payload;
    },
    updatePaymentMethodValue: (state, action) => {
      const { payment_method, value } = action.payload;
      state.cashierPaymentMethods = state.cashierPaymentMethods.map((method) =>
        method.payment_method === payment_method
          ? { ...method, value, error: false, helperText: "" }
          : method
      );
    },
    validatePaymentMethods: (state) => {
      let isValid = true;

      state.cashierPaymentMethods.forEach((method) => {
        if (!method.value) {
          isValid = false;
          method.error = true;
          method.helperText = "Este campo é obrigatório";
        } else {
          method.error = false;
          method.helperText = "";
        }
      });

      state.isValid = isValid; // Directly set isValid on the state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const {
  setCashier,
  setShowNewCashierModal,
  setShowCashierInfosModal,
  setCashierPaymentMethods,
  updatePaymentMethodValue,
  validatePaymentMethods,
} = cashierSlice.actions;
export default cashierSlice.reducer;
